<template>
  <CFormTextarea :id="String(id)" rows="3" placeholder="請填入文字">
  </CFormTextarea>
</template>
<script>
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  setup() {},
}
</script>
